import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { NgbActiveModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { EventManager, JhiLanguageService } from 'ng-jhipster';

import { Marketplace } from './marketplace.model';
import { MarketplacePopupService } from './marketplace-popup.service';
import { MarketplaceService } from './marketplace.service';

@Component({
    selector: 'jhi-marketplace-delete-dialog',
    templateUrl: './marketplace-delete-dialog.component.html'
})
export class MarketplaceDeleteDialogComponent {

    marketplace: Marketplace;

    constructor(
        private jhiLanguageService: JhiLanguageService,
        private marketplaceService: MarketplaceService,
        public activeModal: NgbActiveModal,
        private eventManager: EventManager
    ) {
        this.jhiLanguageService.setLocations(['marketplace']);
    }

    clear() {
        this.activeModal.dismiss('cancel');
    }

    confirmDelete(id: number) {
        this.marketplaceService.delete(id).subscribe((response) => {
            this.eventManager.broadcast({
                name: 'marketplaceListModification',
                content: 'Deleted an marketplace'
            });
            this.activeModal.dismiss(true);
        });
    }
}

@Component({
    selector: 'jhi-marketplace-delete-popup',
    template: ''
})
export class MarketplaceDeletePopupComponent implements OnInit, OnDestroy {

    modalRef: NgbModalRef;
    routeSub: any;

    constructor(
        private route: ActivatedRoute,
        private marketplacePopupService: MarketplacePopupService
    ) {}

    ngOnInit() {
        this.routeSub = this.route.params.subscribe((params) => {
            this.modalRef = this.marketplacePopupService
                .open(MarketplaceDeleteDialogComponent, params['id']);
        });
    }

    ngOnDestroy() {
        this.routeSub.unsubscribe();
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/marketplace/marketplace-delete-dialog.component.ts